import { __decorate } from "tslib";
import { Vue, Component, Inject, Prop } from 'vue-property-decorator';
let TableBaseMixin = class TableBaseMixin extends Vue {
  get rootVm() {
    const _rootVM = this.amRootVm || this.caller || {};
    if (!_rootVM.global) _rootVM.global = {};
    return _rootVM;
  }
};
__decorate([Prop({
  type: Object,
  default: () => {}
})], TableBaseMixin.prototype, "caller", void 0);
__decorate([Inject('amRootVm')], TableBaseMixin.prototype, "amRootVm", void 0);
TableBaseMixin = __decorate([Component({
  name: 'TableBaseMixin'
})], TableBaseMixin);
export default TableBaseMixin;